module.exports = __webpack_public_path__ + "static/media/ship_pink_flip.49042447.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ship_pink_flip.png
// module id = 212
// module chunks = 0